<template>
  <f7-page name="hydro-nadrze" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Teploty vodných nádrží</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-block class="no-margin no-padding">

        <template v-if="nadrzeData.length > 0">

          <f7-card class="n-c-wrapper">
            <f7-card-header class="n-c-header">
              {{ nadrzeDt * 1000 | moment('DD.MM.YYYY') }}
            </f7-card-header>
            <f7-card-content>
              <f7-list>
                <f7-list-item v-for="item in nadrzeData" :key="item.nadrz_id"
                              :title="item.nadrz_nazov" :after="formatTeplota(item.teplota)" >
                </f7-list-item>
              </f7-list>
            </f7-card-content>
            <f7-card-footer>
              Zdroj: SVP, š.p.
            </f7-card-footer>
          </f7-card>


        </template>

      </f7-block>

    </template>




  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";


export default {
  data: function () {
    return {
      nadrzeData: [],
      isDataLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
    };
  },
  computed: {
    nadrzeDt() {
      if (this.nadrzeData.length) {
          return this.nadrzeData.reduce((prev, current) => (prev.dt_ts > current.dt_ts) ? prev.dt_ts : current.dt_ts)
      }
    }
  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-vodne-zdroje');
    this.$f7.accordion.open('.shmu-i-vodne-zdroje');

  },
  updated() {


  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'hydro/getwatertanksdata', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.nadrzeData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne teploty vodných nádrží', 'Nastala chyba');
              }

              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    formatTeplota(t) {
      if (t === '-' || t == null) {
        return '-';
      }

      return t + ' °C'
    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    }
  }

};
</script>

<style lang="scss">
.n-c-header {
  justify-content: center;
  font-weight: bold;
}

.n-c-wrapper {
  .item-after {
    font-weight: bold;
    color: var(--f7-card-header-text-color);
  }
}

</style>
